import { Timestamp } from 'firebase/firestore';

const TTL_DAYS = 45;

export function ttlTimestamp(): Timestamp {
  const expiry = new Date();
  expiry.setDate(expiry.getDate() + TTL_DAYS);
  return Timestamp.fromDate(expiry);
}
